import { ReactElement, useCallback } from 'react';

import { createFetchContext } from '../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../components/info/DisplayError';
import Loading from '../../../components/info/Loading';
import { getDegreeProcess } from '../requests';
import { DegreeProcessResponse } from '../types';

export interface DegreeProcessLoaderProps<T> {
  studyPlanEnrollmentId: number;
  children: (props: { data: T; refresh: () => Promise<void> }) => ReactElement;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  undefined,
  DegreeProcessResponse
>();

export const DegreeProcessLoaderConsumer = FetchConsumer;

export default function DegreeProcessLoader({
  studyPlanEnrollmentId,
  children,
}: DegreeProcessLoaderProps<DegreeProcessResponse>) {
  const request = useCallback(() => {
    return getDegreeProcess(studyPlanEnrollmentId);
  }, [studyPlanEnrollmentId]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                body={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return <Loading insideCard />;
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                body="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children({ data, refresh });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
